<div class="banner-section">
  <div class="banner-overlay"></div>
  <div class="banner-container">
    <div class="banner-row-split">
      <!-- Columna izquierda: título + subtítulo -->
      <div class="banner-text">
        <h1>Bienvenido a Signo Médico</h1>
        <p>
          <strong>Realice sus trámites de forma online a través de nuestra plataforma</strong>
        </p>
      </div>

      <!-- Columna derecha: Google Play Card -->
      <div class="google-play-card">
        <p>
          Si ya ha registrado su usuario, le invitamos a descargar
          nuestra aplicación móvil.
        </p>
        <img
          src="assets/img/google-play-badge.png"
          alt="Descarga nuestra app en Google Play"
          class="google-play-badge"
          (click)="irGooglePlay()"
        />
      </div>
    </div>
    <div class="banner-image"></div>
  </div>
</div>